import React from "react";
import Div from "../../../widget/common/ui/Div";
import {
  WorkProfileContextImport,
  WorkProfileContextProvider,
} from "../../../provider/work_profile/work_profile/WorkProfileContextProvider";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { IconNormal } from "../../../widget/common/ui/Icon";
import AppTheme from "../../../service/app_config/AppTheme";
import { CheckBoxRound } from "../../../widget/common/ui/Checkbox";

const WorkProfileAlert = () => {
  return (
    <WorkProfileContextProvider>
      <WorkProfileAlertBody />
    </WorkProfileContextProvider>
  );
};

export default WorkProfileAlert;

const WorkProfileAlertBody = () => {
  const { menus, handleClick } = WorkProfileContextImport();

  return (
    <Div>
      {menus.map((menu, key) => (
        <div
          key={key}
          role="button"
          className="pb-3 d-flex align-items-center justify-content-between w-100 font-size-16_17 font-gotham-book color-black"
          onClick={() => handleClick(menu.name)}
        >
          <div className="d-flex  align-items-center">
            <IconNormal name={menu.icon} color={AppTheme.black} size={40} />
            <div className="ps-3">{AppTranslation.text(menu.name)}</div>
          </div>

          <div>
            <CheckBoxRound
              status={menu.status}
              fillColor={
                menu.status ? "bgcolor-black" : "bgcolor-theme-sublabel"
              }
            />
          </div>
        </div>
      ))}
    </Div>
  );
};
